import { type ReactNode } from "react";
import { GripVertical } from "lucide-react";
import { Card } from "../../molecules/Card/index.js";
import { WidgetErrorBoundary, WidgetSlot } from "./WidgetErrorBoundary.js";
import { widgetLabel } from "./helpers.js";
import type { DashboardItem } from "./types.js";

/** The card cloned under the pointer during a drag. Its body renders through
 *  the same per-widget error boundary as the grid cells, so a widget that
 *  throws mid-drag is isolated rather than crashing the dashboard. */
export function OverlayCard({
  item,
  renderWidget,
}: {
  item: DashboardItem;
  renderWidget: (item: DashboardItem) => ReactNode;
}) {
  return (
    /* Card `dragging` (AP-05): the large shadow and the neutral strong
       border, never the accent. */
    <Card dragging className="flex h-full flex-col">
      <div className="flex min-h-10 items-center gap-1.5 border-b border-pb-border/70 bg-pb-card-elevated/50 px-2.5 py-1 select-none">
        <GripVertical
          className="mx-2 h-4 w-4 shrink-0 text-pb-text-muted"
          aria-hidden
        />
        <div className="min-w-0 flex-1 truncate text-xs font-medium text-pb-text-secondary">
          {widgetLabel(item)}
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden pointer-events-none opacity-90 text-pb-text [&>*]:!border-0 [&>*]:!rounded-none [&>*]:!shadow-none">
        <WidgetErrorBoundary
          widgetName={widgetLabel(item)}
          resetKeys={[item.instanceId, item.params]}
        >
          <WidgetSlot item={item} renderWidget={renderWidget} />
        </WidgetErrorBoundary>
      </div>
    </Card>
  );
}
